import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from "../Context/CartContext";
import { PERGOLAS_DECKS_IMAGES } from '../utils/imageUrls';

const projects = [
    {
        id: 16,
        title: "בית עץ",
        mainImage: PERGOLAS_DECKS_IMAGES.playHouse,
        galleryImages: PERGOLAS_DECKS_IMAGES.playHouseGallery,
        sizes: ['לבחירת לקוח'],
        woodTypes: ['אורן'],
        price: "בהתאמה אישית" // שונה מ-"---" למראה יוקרתי
    },
    {
        id: 17,
        title: "פרגולה מעץ",
        mainImage: PERGOLAS_DECKS_IMAGES.pergola,
        galleryImages: PERGOLAS_DECKS_IMAGES.pergolaGallery,
        sizes: ['לבחירת לקוח'],
        woodTypes: ['אורן'],
        price: "בהתאמה אישית"
    },
    {
        id: 18,
        title: 'גדרות',
        mainImage: PERGOLAS_DECKS_IMAGES.fence,
        galleryImages: PERGOLAS_DECKS_IMAGES.fenceGallery,
        sizes: ['לבחירת לקוח'],
        woodTypes: ['אורן'],
        price: "החל מ-₪450"
    },
    {
        id: 20,
        title: 'דק',
        mainImage: PERGOLAS_DECKS_IMAGES.deck,
        galleryImages: PERGOLAS_DECKS_IMAGES.deckGallery,
        sizes: ['לבחירת לקוח'],
        woodTypes: ['אורן'],
        price: "בהתאמה אישית"
    },
];

export { projects };

function PergolasAndDecks() {
    const { addToItem } = useContext(CartContext);
    const navigate = useNavigate();

    const handleClick = (project) => {
        addToItem(project);
        navigate(`/product-page/${project.id}`, { state: { project } });
    };

    return (
        <div className="py-10 px-4 sm:px-6 lg:px-8 bg-background flex flex-col items-center">
            <div className="text-center mb-16">
                <h1 className="text-3xl md:text-5xl font-medium text-text-primary tracking-wide mb-4">
                    פרגולות ודקים
                </h1>
                <div className="w-16 h-1 bg-accent mx-auto rounded-full"></div>
            </div>

            {/* גריד המוצרים - סגנון גלריה */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 w-full max-w-7xl mx-auto">
                {projects.map(project => (
                    <div
                        key={project.id}
                        onClick={() => handleClick(project)}
                        className="group bg-surface rounded-2xl overflow-hidden shadow-soft hover:shadow-hover cursor-pointer transition-all duration-500 flex flex-col border border-transparent hover:border-secondary-dark"
                    >
                        {/* תמונה עם זום עדין */}
                        <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
                            <img
                                src={project.mainImage}
                                alt={project.title}
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                            />
                            {/* פילטר כהה עדין מאוד בהובר */}
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-500" />
                        </div>

                        {/* אזור הטקסט */}
                        <div className="p-6 text-center flex flex-col flex-grow justify-between bg-surface z-10 relative">
                            <div>
                                <h2 className="text-xl md:text-2xl font-medium text-text-primary mb-1">
                                    {project.title}
                                </h2>
                                <p className="text-text-secondary text-sm font-light">
                                    {project.price}
                                </p>
                            </div>

                            {/* קו אינטראקציה תחתון שמתרחב ומשנה צבע בהובר */}
                            <div className="w-8 h-0.5 bg-secondary-dark mx-auto mt-6 transition-all duration-300 group-hover:w-16 group-hover:bg-accent" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PergolasAndDecks;